const parseFemiMoney = (value) => {
  const normalized = String(value || '')
    .replace(/[^\d,.-]/g, '')
    .replace(/\.(?=\d{3}(?:\D|$))/g, '')
    .replace(',', '.');
  return Number.parseFloat(normalized);
};

const syncFemiPackage = (input) => {
  if (!input) return;
  const form = input.closest('form');
  if (!form) return;
  const variant = form.querySelector('[name="id"]');
  const quantity = form.querySelector('[name="quantity"]');
  if (variant && input.dataset.variantId) variant.value = input.dataset.variantId;
  if (quantity) quantity.value = input.dataset.variantId ? '1' : (input.dataset.quantity || '1');

  const card = input.closest('[data-femi-package-card]');
  const productPage = input.closest('.femi-product-page');
  const topPrice = productPage?.querySelector('[data-femi-top-price]');
  const topCompare = productPage?.querySelector('[data-femi-top-compare]');
  const saleBadge = productPage?.querySelector('[data-femi-sale-badge]');
  const atcPrice = form.querySelector('[data-femi-atc-price]');
  const atcCompare = form.querySelector('[data-femi-atc-compare]');
  const stickyPrice = productPage?.querySelector('[data-femi-sticky-price]');
  const stickyImage = productPage?.querySelector('.femi-sticky-atc__image');
  if (card && topPrice) topPrice.textContent = card.dataset.price || topPrice.textContent;
  if (card && topCompare) {
    topCompare.textContent = card.dataset.compare || '';
    topCompare.style.display = card.dataset.compare ? '' : 'none';
  }
  if (card && atcPrice) atcPrice.textContent = card.dataset.price || atcPrice.textContent;
  if (card && atcCompare) {
    atcCompare.textContent = card.dataset.compare || '';
    atcCompare.style.display = card.dataset.compare ? '' : 'none';
  }
  if (card && stickyPrice) stickyPrice.textContent = card.dataset.price || stickyPrice.textContent;
  const packageImage = card?.querySelector('img');
  if (packageImage && stickyImage) {
    stickyImage.src = packageImage.currentSrc || packageImage.src;
    stickyImage.alt = packageImage.alt;
  }
  if (card && saleBadge) {
    const price = parseFemiMoney(card.dataset.price);
    const compare = parseFemiMoney(card.dataset.compare);
    const discount = Number.isFinite(price) && Number.isFinite(compare) && compare > price
      ? Math.round((1 - (price / compare)) * 100)
      : 0;
    const prefix = saleBadge.dataset.prefix
      || saleBadge.textContent.replace(/\s*\d+\s*%.*$/, '').trim()
      || 'ПРОМО';
    saleBadge.dataset.prefix = prefix;
    saleBadge.textContent = discount > 0 ? `${prefix} ${discount}%` : '';
    saleBadge.hidden = discount <= 0;
  }
};

const initFemiPackages = (root = document) => {
  root.querySelectorAll('[data-femi-package]:checked').forEach(syncFemiPackage);
};

document.addEventListener('change', (event) => {
  const input = event.target.closest('[data-femi-package]');
  if (!input) return;
  syncFemiPackage(input);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initFemiPackages());
} else {
  initFemiPackages();
}

document.addEventListener('shopify:section:load', (event) => initFemiPackages(event.target));

const initFemiStickyAtc = (root = document) => {
  root.querySelectorAll('[data-femi-sticky-atc]:not([data-femi-sticky-ready])').forEach((bar) => {
    const productPage = bar.closest('.femi-product-page');
    const mainButton = productPage?.querySelector('.femi-atc');
    const stickyButton = bar.querySelector('[data-femi-sticky-submit]');
    if (!mainButton || !stickyButton) return;

    bar.dataset.femiStickyReady = 'true';
    let ticking = false;

    const updateVisibility = () => {
      const shouldShow = mainButton.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    };

    const syncLoadingState = () => {
      const isLoading = mainButton.getAttribute('aria-disabled') === 'true'
        || mainButton.classList.contains('loading');
      stickyButton.disabled = isLoading;
      stickyButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      stickyButton.classList.toggle('is-loading', isLoading);
    };

    const loadingObserver = new MutationObserver(syncLoadingState);
    loadingObserver.observe(mainButton, {
      attributes: true,
      attributeFilter: ['aria-disabled', 'class']
    });

    stickyButton.addEventListener('click', () => {
      if (mainButton.getAttribute('aria-disabled') === 'true') return;
      stickyButton.disabled = true;
      stickyButton.setAttribute('aria-busy', 'true');
      stickyButton.classList.add('is-loading');
      mainButton.click();
      syncLoadingState();
    });
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    syncLoadingState();
    updateVisibility();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initFemiStickyAtc());
} else {
  initFemiStickyAtc();
}

document.addEventListener('shopify:section:load', (event) => initFemiStickyAtc(event.target));

const calculateFemiDeliveryDate = (now, weekdayCutoffHour, saturdayCutoffHour) => {
  const result = new Date(now);
  const day = result.getDay();
  const hour = result.getHours();
  let daysToAdd;

  if (day >= 1 && day <= 4) {
    daysToAdd = hour < weekdayCutoffHour ? 1 : 2;
  } else if (day === 5) {
    daysToAdd = hour < weekdayCutoffHour ? 1 : 4;
  } else if (day === 6) {
    daysToAdd = hour < saturdayCutoffHour ? 2 : 3;
  } else {
    daysToAdd = 2;
  }

  result.setDate(result.getDate() + daysToAdd);
  result.setHours(12, 0, 0, 0);
  return result;
};

const initFemiDeliveryEstimates = (root = document) => {
  root.querySelectorAll('[data-femi-delivery-estimate]').forEach((estimate) => {
    const target = estimate.querySelector('[data-femi-delivery-date]');
    if (!target) return;
    const cutoffHour = Number(estimate.dataset.cutoffHour || 16);
    const saturdayCutoffHour = Number(estimate.dataset.saturdayCutoffHour || 12);
    const deliveryDate = calculateFemiDeliveryDate(new Date(), cutoffHour, saturdayCutoffHour);
    target.textContent = new Intl.DateTimeFormat('bg-BG', {
      day: 'numeric',
      month: 'long'
    }).format(deliveryDate);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initFemiDeliveryEstimates());
} else {
  initFemiDeliveryEstimates();
}

document.addEventListener('shopify:section:load', (event) => initFemiDeliveryEstimates(event.target));

const initFemilabsProgress = (root = document) => {
  const bars = root.querySelectorAll('[data-femi-benefit-progress]:not([data-femi-progress-ready])');
  if (!bars.length) return;

  const showBar = (bar) => {
    bar.dataset.femiProgressReady = 'true';
    window.requestAnimationFrame(() => bar.classList.add('is-animated'));
  };

  if (!('IntersectionObserver' in window)) {
    bars.forEach(showBar);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      showBar(entry.target);
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.35 });

  bars.forEach((bar) => observer.observe(bar));
};

const initFemilabsReveal = () => {
  const targets = document.querySelectorAll([
    '.femi-product .femi-gallery',
    '.femi-info > *',
    '.femi-anchor a',
    '.femi-section h2',
    '.femi-day',
    '.femi-formula-feature',
    '.femi-formula__image',
    '.femi-why-card',
    '.femi-result',
    '.femi-post',
    '.femi-faq details'
  ].join(','));

  targets.forEach((target) => target.classList.add('femi-reveal'));

  if (!('IntersectionObserver' in window)) {
    targets.forEach((target) => target.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });

  targets.forEach((target) => observer.observe(target));
};

const updateFemiGalleryControls = (gallery) => {
  const thumbs = Array.from(gallery?.querySelectorAll('[data-femi-gallery-thumb]') || []);
  if (!gallery || !thumbs.length) return;

  const activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
  gallery.querySelectorAll('[data-femi-gallery-nav]').forEach((button) => {
    const atBoundary = button.dataset.femiGalleryNav === 'prev'
      ? activeIndex === 0
      : activeIndex === thumbs.length - 1;
    button.hidden = atBoundary;
    button.disabled = atBoundary;
    button.setAttribute('aria-hidden', atBoundary ? 'true' : 'false');
  });
};

const setFemiGallerySlide = (gallery, target, options = {}) => {
  const main = gallery?.querySelector('[data-femi-gallery-main]');
  if (!gallery || !main || !target?.dataset.fullSrc) return;

  if (options.instant) {
    main.src = target.dataset.fullSrc;
    main.alt = target.dataset.alt || main.alt;
    main.classList.remove('is-changing');
  } else {
    main.classList.add('is-changing');
    window.setTimeout(() => {
      main.src = target.dataset.fullSrc;
      main.alt = target.dataset.alt || main.alt;
      if (main.complete) main.classList.remove('is-changing');
    }, 110);
    main.addEventListener('load', () => main.classList.remove('is-changing'), { once: true });
  }

  const track = gallery.querySelector('[data-femi-gallery-track]');
  const thumbs = Array.from(gallery.querySelectorAll('[data-femi-gallery-thumb]'));
  thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb === target));
  updateFemiGalleryControls(gallery);
  gallery.dispatchEvent(new CustomEvent('femi:gallery-change'));
  if (!track) return;

  const targetCenter = target.offsetLeft + target.offsetWidth / 2;
  const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
  const nextScroll = Math.min(maxScroll, Math.max(0, targetCenter - track.clientWidth / 2));
  track.style.removeProperty('transform');
  track.scrollTo({ left: nextScroll, behavior: 'smooth' });
};

const moveFemiGallery = (gallery, direction) => {
  const thumbs = Array.from(gallery?.querySelectorAll('[data-femi-gallery-thumb]') || []);
  if (!thumbs.length) return;
  const activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
  const nextIndex = Math.min(thumbs.length - 1, Math.max(0, activeIndex + direction));
  if (nextIndex !== activeIndex) setFemiGallerySlide(gallery, thumbs[nextIndex]);
};

const setFemiProofSlide = (slider, nextIndex) => {
  const cards = Array.from(slider?.querySelectorAll('.femi-proof-card') || []);
  if (!cards.length) return;
  const normalizedIndex = (nextIndex + cards.length) % cards.length;

  cards.forEach((card, index) => {
    const active = index === normalizedIndex;
    card.classList.toggle('is-active', active);
    card.setAttribute('aria-hidden', active ? 'false' : 'true');
  });
  slider.querySelectorAll('[data-femi-proof-dot]').forEach((dot, index) => {
    const active = index === normalizedIndex;
    dot.classList.toggle('is-active', active);
    dot.setAttribute('aria-selected', active ? 'true' : 'false');
  });
};

const activateFemiDetailTab = (tabs, key, focusTab = false) => {
  if (!tabs || !key) return;
  const productPage = tabs.closest('.femi-product-page');
  const activeTab = tabs.querySelector(`[data-femi-detail-tab="${key}"]`);
  if (!productPage || !activeTab) return;

  tabs.querySelectorAll('[data-femi-detail-tab]').forEach((tab) => {
    const active = tab === activeTab;
    tab.classList.toggle('is-active', active);
    tab.setAttribute('aria-selected', active ? 'true' : 'false');
    tab.tabIndex = active ? 0 : -1;
  });
  productPage.querySelectorAll('[data-femi-detail-panel]').forEach((panel) => {
    const active = panel.dataset.femiDetailPanel === key;
    panel.hidden = !active;
    panel.classList.toggle('is-active', active);
  });
  if (focusTab) activeTab.focus({ preventScroll: true });
};

const initFemilabsSwipe = (root = document) => {
  root.querySelectorAll('.femi-gallery').forEach((gallery) => {
    const thumbs = Array.from(gallery.querySelectorAll('[data-femi-gallery-thumb]'));
    if (thumbs.length && !thumbs.some((thumb) => thumb.classList.contains('is-active'))) {
      thumbs[0].classList.add('is-active');
    }
    updateFemiGalleryControls(gallery);
  });

  root.querySelectorAll('[data-femi-gallery-stage]:not([data-femi-swipe-ready])').forEach((stage) => {
    stage.dataset.femiSwipeReady = 'true';
    let startX = 0;
    let startY = 0;
    let pointerId = null;
    let pointerType = 'mouse';
    let touchIdentifier = null;
    let gestureAxis = null;
    let lastX = 0;
    let lastY = 0;
    let dragged = false;
    let dragDirection = 0;
    let dragTarget = null;
    let dragPreview = null;
    const dragPreviews = new Map();
    const main = stage.querySelector('[data-femi-gallery-main]');
    const gallery = stage.closest('.femi-gallery');

    const clearDragPreview = () => {
      dragTarget = null;
      dragPreview = null;
      dragDirection = 0;
      const stageWidth = stage.clientWidth;
      dragPreviews.forEach((preview, direction) => {
        const previewStart = direction > 0 ? stageWidth : -stageWidth;
        preview.style.transform = `translate3d(${previewStart}px, 0, 0)`;
      });
    };

    const getDragTarget = (direction) => {
      const thumbs = Array.from(gallery?.querySelectorAll('[data-femi-gallery-thumb]') || []);
      const activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
      const nextIndex = activeIndex + direction;
      return nextIndex >= 0 && nextIndex < thumbs.length ? thumbs[nextIndex] : null;
    };

    const ensureDragPreview = (target, direction) => {
      if (!target?.dataset.fullSrc) return null;
      let preview = dragPreviews.get(direction);
      if (!preview) {
        preview = document.createElement('img');
        preview.className = 'femi-gallery__drag-preview';
        preview.decoding = 'async';
        preview.setAttribute('aria-hidden', 'true');
        stage.appendChild(preview);
        dragPreviews.set(direction, preview);
      }

      if (preview.dataset.fullSrc !== target.dataset.fullSrc) {
        preview.dataset.fullSrc = target.dataset.fullSrc;
        preview.src = target.dataset.fullSrc;
        preview.alt = target.dataset.alt || '';
        preview.decode?.().catch(() => {});
      }

      preview.hidden = false;
      dragTarget = target;
      dragPreview = preview;
      return preview;
    };

    const primeGalleryPreviews = () => {
      [-1, 1].forEach((direction) => {
        const target = getDragTarget(direction);
        const existingPreview = dragPreviews.get(direction);
        if (target) {
          ensureDragPreview(target, direction);
        } else if (existingPreview) {
          existingPreview.hidden = true;
        }
      });
      clearDragPreview();
    };

    const beginGalleryGesture = (clientX, clientY, type) => {
      pointerType = type;
      startX = clientX;
      startY = clientY;
      lastX = clientX;
      lastY = clientY;
      gestureAxis = null;
      dragged = false;
      clearDragPreview();
      stage.classList.remove('is-settling', 'is-swiping');
      if (main) main.style.removeProperty('transform');
    };

    const resetGalleryGesture = () => {
      stage.classList.remove('is-settling', 'is-swiping');
      pointerId = null;
      touchIdentifier = null;
      gestureAxis = null;
      dragged = false;
      if (main) main.style.removeProperty('transform');
      clearDragPreview();
    };

    const updateGalleryGesture = (clientX, clientY, preventDefault) => {
      const deltaX = clientX - startX;
      const deltaY = clientY - startY;
      const absX = Math.abs(deltaX);
      const absY = Math.abs(deltaY);
      lastX = clientX;
      lastY = clientY;

      if (!gestureAxis) {
        const lockDistance = pointerType === 'touch' ? 10 : 6;
        if (Math.max(absX, absY) < lockDistance) return;

        const horizontalBias = pointerType === 'touch' ? 1.08 : 1;
        if (absX > absY * horizontalBias) {
          gestureAxis = 'horizontal';
          dragged = true;
          stage.classList.add('is-swiping');
        } else if (absY > absX * horizontalBias) {
          gestureAxis = 'vertical';
          return;
        } else {
          return;
        }
      }

      if (gestureAxis !== 'horizontal') return;
      preventDefault?.();

      if (main) {
        const dragLimit = stage.clientWidth;
        const nextDirection = deltaX < 0 ? 1 : -1;
        const target = getDragTarget(nextDirection);
        const preview = ensureDragPreview(target, nextDirection);
        dragDirection = nextDirection;
        const rawOffset = target ? deltaX : deltaX * 0.18;
        const dragOffset = Math.max(-dragLimit, Math.min(dragLimit, rawOffset));
        main.style.transform = `translate3d(${dragOffset}px, 0, 0)`;
        if (preview) {
          const previewStart = dragDirection > 0 ? dragLimit : -dragLimit;
          preview.style.transform = `translate3d(${previewStart + dragOffset}px, 0, 0)`;
        }
      }
    };

    const finishGalleryGesture = (clientX = lastX, clientY = lastY) => {
      const deltaX = clientX - startX;
      const horizontalGesture = gestureAxis === 'horizontal' && dragged;
      const distanceThreshold = pointerType === 'touch' ? 28 : 44;
      const accepted = horizontalGesture
        && dragTarget
        && Math.abs(deltaX) >= distanceThreshold;

      stage.classList.remove('is-swiping');
      pointerId = null;
      touchIdentifier = null;

      if (!horizontalGesture) {
        gestureAxis = null;
        dragged = false;
        if (main) main.style.removeProperty('transform');
        clearDragPreview();
        return;
      }

      const stageWidth = stage.clientWidth;
      const settledTarget = dragTarget;
      stage.classList.add('is-settling');

      if (accepted) {
        const exitOffset = dragDirection > 0 ? -stageWidth : stageWidth;
        if (main) main.style.transform = `translate3d(${exitOffset}px, 0, 0)`;
        if (dragPreview) dragPreview.style.transform = 'translate3d(0, 0, 0)';
      } else {
        if (main) main.style.transform = 'translate3d(0, 0, 0)';
        if (dragPreview) {
          const previewStart = dragDirection > 0 ? stageWidth : -stageWidth;
          dragPreview.style.transform = `translate3d(${previewStart}px, 0, 0)`;
        }
      }

      window.setTimeout(() => {
        stage.classList.remove('is-settling');
        stage.classList.add('is-swiping');
        if (accepted && settledTarget) setFemiGallerySlide(gallery, settledTarget, { instant: true });
        if (main) main.style.transform = 'translate3d(0, 0, 0)';
        window.requestAnimationFrame(() => {
          clearDragPreview();
          if (main) main.style.removeProperty('transform');
          stage.classList.remove('is-swiping');
          gestureAxis = null;
          dragged = false;
        });
      }, 220);
    };

    stage.addEventListener('dragstart', (event) => event.preventDefault());
    gallery.addEventListener('femi:gallery-change', primeGalleryPreviews);
    primeGalleryPreviews();

    stage.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || event.pointerType === 'touch' || (event.pointerType === 'mouse' && event.button !== 0)) return;
      pointerId = event.pointerId;
      beginGalleryGesture(event.clientX, event.clientY, event.pointerType || 'mouse');
      stage.setPointerCapture?.(pointerId);
    });
    stage.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      updateGalleryGesture(event.clientX, event.clientY, () => {
        if (event.cancelable) event.preventDefault();
      });
    });
    const finishPointerSwipe = (event) => {
      if (event.pointerId !== pointerId) return;
      stage.releasePointerCapture?.(pointerId);
      finishGalleryGesture(event.clientX, event.clientY);
    };
    stage.addEventListener('pointerup', finishPointerSwipe);
    stage.addEventListener('pointercancel', (event) => {
      if (event.pointerId !== pointerId) return;
      stage.releasePointerCapture?.(pointerId);
      resetGalleryGesture();
    });

    stage.addEventListener('touchstart', (event) => {
      if (touchIdentifier !== null || event.touches.length !== 1) return;
      const touch = event.changedTouches[0];
      if (!touch) return;
      touchIdentifier = touch.identifier;
      beginGalleryGesture(touch.clientX, touch.clientY, 'touch');
    }, { passive: true });

    stage.addEventListener('touchmove', (event) => {
      if (touchIdentifier === null) return;
      const touch = Array.from(event.touches).find((item) => item.identifier === touchIdentifier);
      if (!touch) return;
      updateGalleryGesture(touch.clientX, touch.clientY, () => {
        if (event.cancelable) event.preventDefault();
      });
    }, { passive: false });

    stage.addEventListener('touchend', (event) => {
      if (touchIdentifier === null) return;
      const touch = Array.from(event.changedTouches).find((item) => item.identifier === touchIdentifier);
      if (touch) finishGalleryGesture(touch.clientX, touch.clientY);
      else finishGalleryGesture();
    }, { passive: true });

    stage.addEventListener('touchcancel', () => resetGalleryGesture(), { passive: true });
  });

  root.querySelectorAll('[data-femi-gallery-track]:not([data-femi-drag-ready])').forEach((track) => {
    track.dataset.femiDragReady = 'true';
    let pointerId = null;
    let startX = 0;
    let startScroll = 0;
    let dragged = false;

    track.addEventListener('dragstart', (event) => event.preventDefault());
    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      dragged = false;
      track.setPointerCapture?.(pointerId);
    });
    track.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const deltaX = event.clientX - startX;
      if (Math.abs(deltaX) <= 5) return;
      dragged = true;
      event.preventDefault();
      track.classList.add('is-dragging');
      track.scrollLeft = startScroll - deltaX * 1.6;
    });
    const finishThumbDrag = (event) => {
      if (event.pointerId !== pointerId) return;
      track.releasePointerCapture?.(pointerId);
      pointerId = null;
      track.classList.remove('is-dragging');
      if (!dragged) return;
      track.dataset.femiSuppressClick = 'true';
      window.setTimeout(() => delete track.dataset.femiSuppressClick, 0);
    };
    track.addEventListener('pointerup', finishThumbDrag);
    track.addEventListener('pointercancel', finishThumbDrag);
  });

  root.querySelectorAll('[data-femi-why-track]:not([data-femi-swipe-ready])').forEach((track) => {
    track.dataset.femiSwipeReady = 'true';
    let pointerId = null;
    let startX = 0;
    let startScroll = 0;
    let dragged = false;

    track.addEventListener('dragstart', (event) => event.preventDefault());
    track.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      dragged = false;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.setPointerCapture?.(pointerId);
    });
    track.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const delta = event.clientX - startX;
      if (Math.abs(delta) > 5) {
        dragged = true;
        track.classList.add('is-dragging');
        track.scrollLeft = startScroll - delta;
      }
    });
    const finishDrag = (event) => {
      if (event.pointerId !== pointerId) return;
      track.releasePointerCapture?.(pointerId);
      pointerId = null;
      track.classList.remove('is-dragging');
      track.style.scrollSnapType = '';
      track.style.scrollBehavior = '';
      if (!dragged) return;
      const cards = Array.from(track.querySelectorAll('.femi-why-card'));
      const trackCenter = track.scrollLeft + track.clientWidth / 2;
      const nearest = cards.reduce((closest, card) => {
        const distance = Math.abs(card.offsetLeft + card.offsetWidth / 2 - trackCenter);
        return distance < closest.distance ? { card, distance } : closest;
      }, { card: null, distance: Number.POSITIVE_INFINITY }).card;
      if (nearest) {
        const left = nearest.offsetLeft - (track.clientWidth - nearest.offsetWidth) / 2;
        window.requestAnimationFrame(() => track.scrollTo({ left, behavior: 'smooth' }));
      }
    };
    track.addEventListener('pointerup', finishDrag);
    track.addEventListener('pointercancel', finishDrag);
  });

  root.querySelectorAll('[data-femi-proof-slider]:not([data-femi-swipe-ready])').forEach((slider) => {
    slider.dataset.femiSwipeReady = 'true';
    const track = slider.querySelector('.femi-proof-track');
    if (!track) return;
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let dragged = false;

    track.addEventListener('dragstart', (event) => event.preventDefault());
    track.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      dragged = false;
      track.classList.add('is-swiping');
      track.setPointerCapture?.(pointerId);
    });
    track.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      if (Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY)) dragged = true;
    });
    track.addEventListener('pointerup', (event) => {
      if (event.pointerId !== pointerId) return;
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      track.releasePointerCapture?.(pointerId);
      track.classList.remove('is-swiping');
      pointerId = null;
      if (!dragged || Math.abs(deltaX) < 36 || Math.abs(deltaX) < Math.abs(deltaY) * 1.15) return;
      const cards = Array.from(slider.querySelectorAll('.femi-proof-card'));
      const current = Math.max(0, cards.findIndex((card) => card.classList.contains('is-active')));
      setFemiProofSlide(slider, current + (deltaX < 0 ? 1 : -1));
    });
    track.addEventListener('pointercancel', (event) => {
      if (event.pointerId !== pointerId) return;
      track.releasePointerCapture?.(pointerId);
      track.classList.remove('is-swiping');
      pointerId = null;
    });
  });
};

const initFemiMobileVideoTestimonials = (root = document) => {
  root.querySelectorAll('.femi-video-testimonials:not([data-femi-mobile-video-ready])').forEach((section) => {
    section.dataset.femiMobileVideoReady = 'true';

    const track = section.querySelector('[data-femi-testimonial-track]');
    const slides = Array.from(section.querySelectorAll('[data-femi-testimonial-slide]'));
    const dots = Array.from(section.querySelectorAll('[data-femi-testimonial-dot]'));
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const isFullWidthPreview = section.classList.contains('femi-video-testimonials--full-width');
    let activeIndex = 0;
    let isVisible = false;
    let scrollTimer;
    let dragPointerId = null;
    let dragStartX = 0;
    let dragStartScroll = 0;
    let dragMoved = false;

    if (!track || !slides.length) return;

    slides.forEach((slide) => {
      const video = slide.querySelector('video');
      if (!video) return;
      video.dataset.femiInitialMuted = video.muted ? 'true' : 'false';
      video.dataset.femiInitialLoop = video.loop ? 'true' : 'false';
    });

    const isCarouselMode = () => mobileQuery.matches || isFullWidthPreview;
    const visibleCount = () => (isFullWidthPreview && !mobileQuery.matches ? 3 : 1);

    const pageStarts = () => {
      const count = visibleCount();
      const pageCount = Math.ceil(slides.length / count);
      const maxStart = Math.max(0, slides.length - count);
      return Array.from({ length: pageCount }, (_, pageIndex) => Math.min(pageIndex * count, maxStart));
    };

    const normalizeIndex = (nextIndex) => {
      const starts = pageStarts();
      return starts.reduce((nearest, index) => (
        Math.abs(index - nextIndex) < Math.abs(nearest - nextIndex) ? index : nearest
      ), starts[0] || 0);
    };

    const pauseVideo = (slide) => {
      const video = slide.querySelector('video');
      if (video) video.pause();
      slide.classList.remove('is-playing');
      const button = slide.querySelector('[data-femi-testimonial-play]');
      if (button?.dataset.playLabel) button.setAttribute('aria-label', button.dataset.playLabel);
    };

    const playActiveVideos = () => {
      const count = visibleCount();
      slides.forEach((slide, index) => {
        const video = slide.querySelector('video');
        const isActive = index >= activeIndex && index < activeIndex + count;
        if (!video || !isActive || !isCarouselMode() || !isVisible || reducedMotionQuery.matches) {
          pauseVideo(slide);
          return;
        }

        const soundOn = slide.dataset.femiSoundOn === 'true';
        video.muted = !soundOn;
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.play().then(() => {
          slide.classList.add('is-playing');
          const button = slide.querySelector('[data-femi-testimonial-play]');
          if (button) {
            button.dataset.playLabel ||= button.getAttribute('aria-label');
            button.setAttribute('aria-label', button.dataset.playLabel.replace('Пусни', 'Спри'));
          }
        }).catch(() => {});
      });
    };

    const setActive = (nextIndex) => {
      activeIndex = normalizeIndex(nextIndex);
      const count = visibleCount();
      slides.forEach((slide, index) => {
        const isActive = index >= activeIndex && index < activeIndex + count;
        slide.classList.toggle('is-active', isActive);
        if (!isActive) {
          slide.dataset.femiSoundOn = 'false';
          const video = slide.querySelector('video');
          const soundButton = slide.querySelector('[data-femi-testimonial-sound]');
          if (video) video.muted = true;
          soundButton?.classList.remove('is-on');
          soundButton?.setAttribute('aria-label', 'Включи звука');
        }
      });
      dots.forEach((dot) => {
        const isActive = Number(dot.dataset.femiTestimonialDot) === activeIndex;
        dot.classList.toggle('is-active', isActive);
        if (isActive) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      playActiveVideos();
    };

    const slideOffset = (slide) => (
      slide.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft
    );

    const nearestSlideIndex = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      return pageStarts().reduce((nearest, index) => {
        const target = Math.min(slideOffset(slides[index]), maxScroll);
        const distance = Math.abs(target - track.scrollLeft);
        return distance < nearest.distance ? { index, distance } : nearest;
      }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
    };

    const scrollToIndex = (nextIndex) => {
      const index = normalizeIndex(nextIndex);
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const left = Math.min(slideOffset(slides[index]), maxScroll);
      track.scrollTo({ left, behavior: reducedMotionQuery.matches ? 'auto' : 'smooth' });
    };

    track.addEventListener('dragstart', (event) => event.preventDefault());
    track.addEventListener('pointerdown', (event) => {
      if (!isFullWidthPreview || event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button')) return;
      dragPointerId = event.pointerId;
      dragStartX = event.clientX;
      dragStartScroll = track.scrollLeft;
      dragMoved = false;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.setPointerCapture?.(dragPointerId);
    });
    track.addEventListener('pointermove', (event) => {
      if (event.pointerId !== dragPointerId) return;
      const deltaX = event.clientX - dragStartX;
      if (Math.abs(deltaX) <= 5) return;
      dragMoved = true;
      event.preventDefault();
      track.classList.add('is-dragging');
      track.scrollLeft = dragStartScroll - deltaX;
    });
    const finishVideoDrag = (event) => {
      if (event.pointerId !== dragPointerId) return;
      track.releasePointerCapture?.(dragPointerId);
      dragPointerId = null;
      track.classList.remove('is-dragging');
      track.style.scrollSnapType = '';
      track.style.scrollBehavior = '';
      if (!dragMoved) return;
      const index = nearestSlideIndex();
      setActive(index);
      scrollToIndex(index);
    };
    track.addEventListener('pointerup', finishVideoDrag);
    track.addEventListener('pointercancel', finishVideoDrag);

    const syncMode = () => {
      if (isCarouselMode()) {
        slides.forEach((slide) => {
          const video = slide.querySelector('video');
          const soundButton = slide.querySelector('[data-femi-testimonial-sound]');
          if (!video) return;
          slide.dataset.femiSoundOn = 'false';
          video.muted = true;
          video.defaultMuted = true;
          video.loop = true;
          video.playsInline = true;
          soundButton?.classList.remove('is-on');
          soundButton?.setAttribute('aria-label', 'Включи звука');
        });
        setActive(nearestSlideIndex());
        return;
      }

      slides.forEach((slide) => {
        const video = slide.querySelector('video');
        pauseVideo(slide);
        if (!video) return;
        video.muted = video.dataset.femiInitialMuted === 'true';
        video.defaultMuted = video.muted;
        video.loop = video.dataset.femiInitialLoop === 'true';
      });
    };

    track.addEventListener('scroll', () => {
      if (!isCarouselMode()) return;
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => setActive(nearestSlideIndex()), 90);
    }, { passive: true });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        if (!isCarouselMode()) return;
        const index = Number(dot.dataset.femiTestimonialDot);
        setActive(index);
        scrollToIndex(index);
      });
    });

    section.querySelectorAll('[data-femi-testimonial-sound]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!isCarouselMode()) return;
        const slide = button.closest('[data-femi-testimonial-slide]');
        const video = slide?.querySelector('video');
        if (!slide || !video) return;
        const soundOn = video.muted;

        if (soundOn) {
          slides.forEach((otherSlide) => {
            if (otherSlide === slide) return;
            const otherVideo = otherSlide.querySelector('video');
            const otherButton = otherSlide.querySelector('[data-femi-testimonial-sound]');
            if (otherVideo) otherVideo.muted = true;
            otherSlide.dataset.femiSoundOn = 'false';
            otherButton?.classList.remove('is-on');
            otherButton?.setAttribute('aria-label', 'Включи звука');
          });
        }

        video.muted = !soundOn;
        slide.dataset.femiSoundOn = soundOn ? 'true' : 'false';
        button.classList.toggle('is-on', soundOn);
        button.setAttribute('aria-label', soundOn ? 'Изключи звука' : 'Включи звука');
        if (soundOn && video.paused) {
          video.play().then(() => slide.classList.add('is-playing')).catch(() => {});
        }
      });
    });

    const observer = new IntersectionObserver((entries) => {
      isVisible = entries[0]?.isIntersecting && entries[0].intersectionRatio >= .35;
      playActiveVideos();
    }, { threshold: [0, .35, .65] });
    observer.observe(section);

    mobileQuery.addEventListener('change', syncMode);
    reducedMotionQuery.addEventListener('change', playActiveVideos);
    syncMode();
  });
};

const initFemiPreviewStickyInfo = (root = document) => {
  root.querySelectorAll('.femi-product-page--doc-refined .femi-info:not([data-femi-sticky-ready])').forEach((info) => {
    info.dataset.femiStickyReady = 'true';
    const desktopQuery = window.matchMedia('(min-width: 991px)');

    const updateStickyTop = () => {
      if (!desktopQuery.matches) {
        info.style.removeProperty('--femi-preview-sticky-top');
        return;
      }

      const topGap = 92;
      const bottomGap = 20;
      const infoHeight = info.getBoundingClientRect().height;
      const stickyTop = Math.min(topGap, window.innerHeight - infoHeight - bottomGap);
      info.style.setProperty('--femi-preview-sticky-top', `${Math.floor(stickyTop)}px`);
    };

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(updateStickyTop);
      resizeObserver.observe(info);
    }
    desktopQuery.addEventListener('change', updateStickyTop);
    window.addEventListener('resize', updateStickyTop, { passive: true });
    updateStickyTop();
  });
};

const initFemiIngredientExplorer = (root = document) => {
  root.querySelectorAll('[data-femi-ingredient-explorer]:not([data-femi-ingredient-ready])').forEach((explorer) => {
    explorer.dataset.femiIngredientReady = 'true';

    const activateIngredient = (index) => {
      explorer.querySelectorAll('[data-femi-ingredient-trigger]').forEach((trigger) => {
        const active = trigger.dataset.femiIngredientTrigger === index;
        trigger.setAttribute('aria-expanded', String(active));
        trigger.closest('.femi-ingredient-explorer__item')?.classList.toggle('is-active', active);
      });

      explorer.querySelectorAll('[data-femi-ingredient-panel]').forEach((panel) => {
        panel.setAttribute('aria-hidden', String(panel.dataset.femiIngredientPanel !== index));
      });

      explorer.querySelectorAll('[data-femi-ingredient-hotspot]').forEach((hotspot) => {
        const active = hotspot.dataset.femiIngredientHotspot === index;
        hotspot.classList.toggle('is-active', active);
        hotspot.setAttribute('aria-pressed', String(active));
      });

      explorer.querySelectorAll('[data-femi-ingredient-current]').forEach((current) => {
        current.hidden = current.dataset.femiIngredientCurrent !== index;
      });
    };

    explorer.addEventListener('click', (event) => {
      const control = event.target.closest('[data-femi-ingredient-trigger], [data-femi-ingredient-hotspot]');
      if (!control || !explorer.contains(control)) return;
      activateIngredient(control.dataset.femiIngredientTrigger || control.dataset.femiIngredientHotspot);
    });

    const initial = explorer.querySelector('[data-femi-ingredient-trigger][aria-expanded="true"]')
      || explorer.querySelector('[data-femi-ingredient-trigger]');
    if (initial) activateIngredient(initial.dataset.femiIngredientTrigger);
  });
};

const initFemiStoryPalette = (root = document) => {
  const pages = [];
  if (root instanceof Element && root.matches('.femi-product-page[data-femi-story-palette]')) pages.push(root);
  root.querySelectorAll?.('.femi-product-page[data-femi-story-palette]').forEach((page) => pages.push(page));

  pages.forEach((page) => {
    if (page.dataset.femiStoryPaletteReady === 'true') return;
    page.dataset.femiStoryPaletteReady = 'true';

    const options = Array.from(page.querySelectorAll('[data-femi-story-palette-option]'));
    if (!options.length) return;
    const allowed = new Set(options.map((option) => option.dataset.femiStoryPaletteOption));
    let palette = page.dataset.femiStoryPalette || 'beige';

    try {
      const stored = window.localStorage.getItem('femilabs-preview-story-palette');
      if (stored && allowed.has(stored)) palette = stored;
    } catch (_error) {
      // Storage may be unavailable in private browsing; the selector still works.
    }

    const applyPalette = (nextPalette, persist = true) => {
      if (!allowed.has(nextPalette)) return;
      page.dataset.femiStoryPalette = nextPalette;
      options.forEach((option) => {
        option.setAttribute('aria-pressed', option.dataset.femiStoryPaletteOption === nextPalette ? 'true' : 'false');
      });
      if (!persist) return;
      try {
        window.localStorage.setItem('femilabs-preview-story-palette', nextPalette);
      } catch (_error) {
        // Keep the live selection even when persistence is unavailable.
      }
    };

    applyPalette(palette, false);
    options.forEach((option) => {
      option.addEventListener('click', () => applyPalette(option.dataset.femiStoryPaletteOption));
    });
  });
};

const initFemilabsProduct = (root = document) => {
  initFemiPreviewStickyInfo(root);
  initFemiIngredientExplorer(root);
  initFemiStoryPalette(root);
  initFemilabsReveal();
  initFemilabsProgress(root);
  initFemilabsSwipe(root);
  initFemiMobileVideoTestimonials(root);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initFemilabsProduct(), { once: true });
} else {
  initFemilabsProduct();
}

document.addEventListener('shopify:section:load', (event) => initFemilabsProduct(event.target));

document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-femi-gallery-thumb]');
  if (!thumb) return;
  const track = thumb.closest('[data-femi-gallery-track]');
  if (track?.dataset.femiSuppressClick === 'true') return;
  const gallery = thumb.closest('.femi-gallery');
  setFemiGallerySlide(gallery, thumb);
});

document.addEventListener('click', (event) => {
  const nav = event.target.closest('[data-femi-gallery-nav]');
  if (!nav) return;
  const direction = nav.dataset.femiGalleryNav === 'prev' ? -1 : 1;
  const gallery = nav.closest('.femi-gallery');
  moveFemiGallery(gallery, direction);
});

document.addEventListener('click', (event) => {
  const nav = event.target.closest('[data-femi-why-nav]');
  if (!nav) return;
  const slider = nav.closest('.femi-why-slider');
  const track = slider?.querySelector('[data-femi-why-track]');
  if (!track) return;
  const direction = nav.dataset.femiWhyNav === 'prev' ? -1 : 1;
  const cards = Array.from(track.querySelectorAll('.femi-why-card'));
  if (!cards.length) return;

  const trackCenter = track.scrollLeft + track.clientWidth / 2;
  const current = cards.reduce((closest, card, index) => {
    const cardCenter = card.offsetLeft + card.offsetWidth / 2;
    const distance = Math.abs(cardCenter - trackCenter);
    return distance < closest.distance ? { index, distance } : closest;
  }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
  const next = Math.max(0, Math.min(cards.length - 1, current + direction));
  const target = cards[next];
  const left = target.offsetLeft - (track.clientWidth - target.offsetWidth) / 2;

  track.scrollTo({ left, behavior: 'smooth' });
});

document.addEventListener('click', (event) => {
  const slider = event.target.closest('[data-femi-proof-slider]');
  if (!slider) return;
  const isPrev = !!event.target.closest('[data-femi-proof-prev]');
  const isNext = !!event.target.closest('[data-femi-proof-next]');
  const dot = event.target.closest('[data-femi-proof-dot]');
  if (!isPrev && !isNext && !dot) return;

  const cards = Array.from(slider.querySelectorAll('.femi-proof-card'));
  if (!cards.length) return;
  const current = Math.max(0, cards.findIndex((card) => card.classList.contains('is-active')));
  const next = dot ? Number(dot.dataset.femiProofDot) : current + (isPrev ? -1 : 1);
  setFemiProofSlide(slider, next);
});

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-femi-testimonial-play]');
  if (!button) return;

  const card = button.closest('.femi-video-testimonial');
  const video = card?.querySelector('video');
  if (!video) return;

  document.querySelectorAll('.femi-video-testimonial video').forEach((item) => {
    if (item === video) return;
    item.pause();
    const itemCard = item.closest('.femi-video-testimonial');
    itemCard?.classList.remove('is-playing');
    const itemButton = itemCard?.querySelector('[data-femi-testimonial-play]');
    if (itemButton?.dataset.playLabel) itemButton.setAttribute('aria-label', itemButton.dataset.playLabel);
  });

  if (video.paused) {
    button.dataset.playLabel ||= button.getAttribute('aria-label');
    video.play().then(() => {
      card.classList.add('is-playing');
      button.setAttribute('aria-label', button.dataset.playLabel.replace('Пусни', 'Спри'));
    }).catch(() => {});
  } else {
    video.pause();
    card.classList.remove('is-playing');
    if (button.dataset.playLabel) button.setAttribute('aria-label', button.dataset.playLabel);
  }
});

document.addEventListener('ended', (event) => {
  if (!event.target.matches('.femi-video-testimonial video')) return;
  const card = event.target.closest('.femi-video-testimonial');
  card?.classList.remove('is-playing');
  const button = card?.querySelector('[data-femi-testimonial-play]');
  if (button?.dataset.playLabel) button.setAttribute('aria-label', button.dataset.playLabel);
}, true);

document.addEventListener('click', (event) => {
  const tab = event.target.closest('[data-femi-tab]');
  if (!tab) return;
  const tabs = tab.closest('[data-femi-tabs]');
  if (!tabs) return;
  const target = tab.dataset.femiTab;

  tabs.querySelectorAll('[data-femi-tab]').forEach((item) => {
    const active = item === tab;
    item.classList.toggle('is-active', active);
    item.setAttribute('aria-selected', active ? 'true' : 'false');
  });
  tabs.querySelectorAll('[data-femi-tab-panel]').forEach((panel) => {
    panel.classList.toggle('is-active', panel.dataset.femiTabPanel === target);
  });
});

document.addEventListener('click', (event) => {
  const tab = event.target.closest('[data-femi-detail-tab]');
  if (!tab) return;
  activateFemiDetailTab(tab.closest('[data-femi-detail-tabs]'), tab.dataset.femiDetailTab);
}, true);

document.addEventListener('keydown', (event) => {
  const tab = event.target.closest('[data-femi-detail-tab]');
  if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
  const tabs = tab.closest('[data-femi-detail-tabs]');
  const items = Array.from(tabs.querySelectorAll('[data-femi-detail-tab]'));
  const current = items.indexOf(tab);
  let next = current;
  if (event.key === 'ArrowLeft') next = (current - 1 + items.length) % items.length;
  if (event.key === 'ArrowRight') next = (current + 1) % items.length;
  if (event.key === 'Home') next = 0;
  if (event.key === 'End') next = items.length - 1;
  event.preventDefault();
  activateFemiDetailTab(tabs, items[next].dataset.femiDetailTab, true);
});

document.addEventListener('shopify:block:select', (event) => {
  const panel = event.target.closest('[data-femi-detail-panel]');
  const tabs = panel?.closest('.femi-product-page')?.querySelector('[data-femi-detail-tabs]');
  if (panel && tabs) activateFemiDetailTab(tabs, panel.dataset.femiDetailPanel);
});

let femiModalScrollY = 0;
let femiModalTrigger = null;
let femiModalScrollLock = null;

const lockFemiBackgroundScroll = () => {
  femiModalScrollLock?.abort();
  femiModalScrollLock = new AbortController();
  const options = { passive: false, signal: femiModalScrollLock.signal };

  const stopOutsideDialog = (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('.femi-modal__dialog')) event.preventDefault();
  };

  window.addEventListener('wheel', stopOutsideDialog, options);
  window.addEventListener('touchmove', stopOutsideDialog, options);
  window.addEventListener('scroll', () => {
    if (Math.abs(window.scrollY - femiModalScrollY) > 1) {
      window.scrollTo({ top: femiModalScrollY, left: 0, behavior: 'auto' });
    }
  }, { passive: true, signal: femiModalScrollLock.signal });
};

const openFemiIngredients = (modal, trigger) => {
  femiModalScrollY = window.scrollY;
  femiModalTrigger = trigger;
  modal.hidden = false;
  document.documentElement.classList.add('femi-modal-open');
  lockFemiBackgroundScroll();
  window.requestAnimationFrame(() => {
    modal.querySelector('.femi-modal__close')?.focus({ preventScroll: true });
  });
};

const closeFemiIngredients = (modal) => {
  modal.hidden = true;
  document.documentElement.classList.remove('femi-modal-open');
  femiModalScrollLock?.abort();
  femiModalScrollLock = null;
  window.scrollTo({ top: femiModalScrollY, left: 0, behavior: 'auto' });
  window.requestAnimationFrame(() => {
    femiModalTrigger?.focus({ preventScroll: true });
    femiModalTrigger = null;
  });
};

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const open = event.target.closest('[data-femi-open-ingredients]');
  const close = event.target.closest('[data-femi-close-ingredients]');
  if (open) {
    const productPage = open.closest('.femi-product-page') || document.querySelector('.femi-product-page');
    const modal = productPage?.querySelector('[data-femi-ingredients-modal]');
    if (modal) openFemiIngredients(modal, open);
    return;
  }

  const modal = event.target.closest('[data-femi-ingredients-modal]');
  if (!modal || modal.hidden) return;
  const clickedOutsideDialog = !event.target.closest('.femi-modal__dialog');
  if (close || clickedOutsideDialog) closeFemiIngredients(modal);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const modal = document.querySelector('[data-femi-ingredients-modal]:not([hidden])');
  if (modal) closeFemiIngredients(modal);
});

document.addEventListener('click', (event) => {
  const option = event.target.closest('[data-femi-quiz-option]');
  if (!option) return;
  const quiz = option.closest('[data-femi-quiz]');
  const current = option.closest('[data-step]');
  if (!quiz || !current) return;

  const steps = Array.from(quiz.querySelectorAll('[data-step]'));
  const currentIndex = steps.indexOf(current);
  current.classList.remove('is-active');
  const next = steps[currentIndex + 1] || quiz.querySelector('[data-result]');
  if (next) next.classList.add('is-active');

  const progress = quiz.querySelector('[data-progress]');
  if (progress) {
    const completed = Math.min(currentIndex + 1, steps.length);
    progress.style.setProperty('--progress', `${Math.round((completed / steps.length) * 100)}%`);
  }
});
